import MessageService from "@/services/message.service.js";
import Auth from "@/services/auth.service";
const authService = new Auth();
// import store from "@/stores/index.js";

export default class MessageUsecase {
  constructor () {
    this.messageService = new MessageService();
  }

  getMessages (options) {
    return this.messageService.list(options);
  }

  async sendMessage (options) {
    try {
      const userId = await authService.getCurrentUserId();
      options.fromUserId = userId;
      const res = await this.messageService.create(options);
      return res;
    } catch (err) {
      console.error(err);
      return false;
    }
  }

  async cancelMessage (options) {
    try {
      const res = await this.messageService.cancel(options);
      return res;
    } catch (err) {
      console.error(err);
      return err;
    }
  }

  async deleteMessage (options) {
    try {
      const res = await this.messageService.delete(options);
      return res;
    } catch (err) {
      console.error(err);
      return err;
    }
  }

  async markMessageAsRead (options) {
    try {
      const res = await this.messageService.read(options);
      return res;
    } catch (err) {
      console.error(err);
      return false;
    }
  }

  getLatestMessages (options) {
    return this.messageService.latestMessageList(options);
  }
}
